export const lightTheme = {
  body: "#e2e2e2",
  text: "#363537",
  toggleBorder: "#fff",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  textFieldBorder: "#cccccc",
  textFieldHoverBorder: "#999999",
  textFieldFocusBorder: "#1976d2", // Material-UI text-field default
};

export const darkTheme = {
  body: "#363537",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  gradient: "linear-gradient(#091236, #1E215D)",
  textFieldBorder: "#555555",
  textFieldHoverBorder: "#888888",
  textFieldFocusBorder: "#90caf9", // Material-UI text-field dark mode
};
